var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',_vm._b({staticClass:"uppercase font-normal text-gray-500 text-xs pb-2 px-6"},'th',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }